export default __webpack_public_path__ + "static/media/icon-sdc-admin.738fba0d.svg";